var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2OfficeBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 46v9h7.09L52 66h-4.43l-3.09-7H40v7h-4v-7h-4.37l-3.07 7H24.2L29 55h7v-9H20V35.11a2 2 0 012.64-1.9 2.06 2.06 0 011.36 2V42h28v-6.89a2 2 0 012.64-1.9 2.06 2.06 0 011.36 2V46H40zm7-31.86A4.14 4.14 0 0042.86 10h-9.72A4.14 4.14 0 0029 14.14V38h18V14.14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Office_bis.9b88aade.svg";
export { SvgE2OfficeBis as ReactComponent };